
import { useContext } from "react";
import apiService from "./globalService"
import { LangContext } from "../providers/LangContext";

export const ReviewService = ()=> {

    const {lang} = useContext(LangContext);

    return {
        getAll: () => {
            return apiService.get(`/wp-json/retro/v1/events?lang=${lang}`);
        },
        getAllCategories:()=>{
            return apiService.get(`/wp-json/wp/v2/media_category`);
        }
    }
}
